


















import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import Modal from '@/components/Modal.vue'
import SuggestionDialog from './SuggestionDialog.vue'
import { SuggestionView, SuggestionListQuery } from '../../entities/suggestions'
import Scrollable from '@/components/Scrollable.vue'
import SuggestionsCard from '@/pages/suggestions/SuggestionsCard.vue'

@Component<SuggestionsList>({
    components: {
        SuggestionDialog,
        Modal,
        Scrollable,
        SuggestionsCard
    }
})
export default class SuggestionsList extends Vue {
    @Prop({ type: Boolean, default: false }) public inDashboard?: boolean
    @Prop({ type: Number, default: 0 }) public suggestionClipLength!: number

    @Getter public suggestionListView!: SuggestionView[]
    @Getter public suggestionListQuery!: SuggestionListQuery

    @Action public loadSuggestionList
    @Action public loadSuggestionListMore

    @Watch('$route')
    public watchRoute() {
        this.refresh()
    }

    public mounted() {
        this.refresh()
    }

    public async refresh() {
        await this.loadSuggestionList({
            ...this.suggestionListQuery,
            mode: this.activeMode
        })
    }

    public loadMore() {
        this.loadSuggestionListMore()
    }

    public get activeMode() {
        return this.$route.params.mode
    }
}
